// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_array from "melange.js/caml_array.js";
import * as Caml_exceptions from "melange.js/caml_exceptions.js";
import * as Caml_float from "melange.js/caml_float.js";
import * as Caml_int64 from "melange.js/caml_int64.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_string from "melange.js/caml_string.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Buffer from "melange/buffer.js";
import * as Stdlib__Format from "melange/format.js";
import * as Stdlib__Int64 from "melange/int64.js";
import * as Stdlib__Printf from "melange/printf.js";

function jd_to_date(jd) {
  const a = jd + 32044 | 0;
  const b = ((a << 2) + 3 | 0) / 146097 | 0;
  const c = a - (Math.imul(146097, b) / 4 | 0) | 0;
  const d = ((c << 2) + 3 | 0) / 1461 | 0;
  const e = c - (Math.imul(1461, d) / 4 | 0) | 0;
  const m = (Math.imul(5, e) + 2 | 0) / 153 | 0;
  const day = (e - ((Math.imul(153, m) + 2 | 0) / 5 | 0) | 0) + 1 | 0;
  const month = (m + 3 | 0) - Math.imul(12, m / 10 | 0) | 0;
  const year = ((Math.imul(100, b) + d | 0) - 4800 | 0) + (m / 10 | 0) | 0;
  return [
    year,
    month,
    day
  ];
}

function jd_of_date(param) {
  const month = param[1];
  const a = (14 - month | 0) / 12 | 0;
  const y = (param[0] + 4800 | 0) - a | 0;
  const m = (month + Math.imul(12, a) | 0) - 3 | 0;
  return (((((param[2] + ((Math.imul(153, m) + 2 | 0) / 5 | 0) | 0) + Math.imul(365, y) | 0) + (y / 4 | 0) | 0) - (y / 100 | 0) | 0) + (y / 400 | 0) | 0) - 32045 | 0;
}

const ps_count_in_ns = [
  0,
  1000
];

const ps_count_in_us = [
  0,
  1000000
];

const ps_count_in_ms = [
  0,
  1000000000
];

const ps_count_in_s = [
  232,
  3567587328
];

const ps_count_in_min = [
  13969,
  3601842176
];

const ps_count_in_hour = [
  838190,
  1362165760
];

const ps_count_in_day = [
  20116567,
  2627207168
];

const ps_day_max = [
  20116567,
  2627207167
];

const day_min = -719528;

const day_max = 2932896;

const min = [
  day_min,
  Caml_int64.zero
];

const max = [
  day_max,
  ps_day_max
];

function neg(param) {
  const d = param[0];
  if (Caml.i64_neq(param[1], Caml_int64.zero)) {
    return [
      -(d + 1 | 0) | 0,
      Caml_int64.sub(ps_count_in_day, param[1])
    ];
  } else {
    return [
      -d | 0,
      Caml_int64.zero
    ];
  }
}

function add(param, param$1) {
  const d = param[0] + param$1[0] | 0;
  const ps = Caml_int64.add(param[1], param$1[1]);
  const ps_clamp = Caml_int64.mod_(ps, ps_count_in_day);
  const d$1 = d + Stdlib__Int64.compare(ps, ps_clamp) | 0;
  return [
    d$1,
    ps_clamp
  ];
}

function sub(s0, s1) {
  return add(s0, neg(s1));
}

function abs(s) {
  if (s[0] < 0) {
    return neg(s);
  } else {
    return s;
  }
}

function v(s) {
  const ps = s[1];
  if (Caml.i64_lt(ps, Caml_int64.zero) || Caml.i64_gt(ps, ps_day_max)) {
    return Stdlib.invalid_arg(Curry._2(Stdlib__Format.sprintf({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "illegal ptime time span: (",
        _1: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* ',' */44,
            _1: {
              TAG: /* Int64 */ 7,
              _0: /* Int_d */ 0,
              _1: /* No_padding */ 0,
              _2: /* No_precision */ 0,
              _3: {
                TAG: /* Char_literal */ 12,
                _0: /* ')' */41,
                _1: /* End_of_format */ 0
              }
            }
          }
        }
      },
      _1: "illegal ptime time span: (%d,%Ld)"
    }), s[0], ps));
  } else {
    return s;
  }
}

function of_d_ps(s) {
  const ps = s[1];
  if (Caml.i64_lt(ps, Caml_int64.zero) || Caml.i64_gt(ps, ps_day_max)) {
    return;
  } else {
    return s;
  }
}

function unsafe_of_d_ps(s) {
  return s;
}

function unsafe_of_d_ps_option(s) {
  return s;
}

function to_d_ps(s) {
  return s;
}

function of_int_s(secs) {
  const d = Stdlib.abs(secs);
  const s_0 = d / 86400 | 0;
  const s_1 = Caml_int64.mul(Caml_int64.of_int32(d % 86400), ps_count_in_s);
  const s = [
    s_0,
    s_1
  ];
  if (secs < 0) {
    return neg(s);
  } else {
    return s;
  }
}

const day_int_min = Stdlib.min_int / 86400 | 0;

const day_int_max = Stdlib.max_int / 86400 | 0;

function to_int_s(param) {
  const d = param[0];
  if (d < day_int_min || d > day_int_max) {
    return;
  }
  const days_s = Math.imul(d, 86400);
  const day_s = Caml_int64.to_int32(Caml_int64.div(param[1], ps_count_in_s));
  const secs = days_s + day_s | 0;
  if (secs < days_s) {
    return;
  } else {
    return secs;
  }
}

const min_int_float = Stdlib.min_int;

const max_int_float = Stdlib.max_int;

function of_float_s(secs) {
  if (secs !== secs) {
    return;
  }
  const days = Math.floor(secs / 86400);
  if (days < min_int_float || days > max_int_float) {
    return;
  }
  const rem_s = secs % 86400;
  const rem_s$1 = rem_s < 0 ? 86400 + rem_s : rem_s;
  if (rem_s$1 >= 86400) {
    const days$1 = days + 1;
    if (days$1 > max_int_float) {
      return;
    } else {
      return [
        days$1 | 0,
        Caml_int64.zero
      ];
    }
  }
  const match = Caml_float.caml_modf_float(rem_s$1);
  const rem_ps = Caml_int64.mul(Caml_int64.of_float(match[1]), ps_count_in_s);
  const frac_ps = Caml_int64.of_float(match[0] * 1e12);
  return [
    days | 0,
    Caml_int64.add(rem_ps, frac_ps)
  ];
}

function to_float_s(param) {
  const ps = param[1];
  const days_s = param[0] * 86400;
  const day_s = Caml_int64.to_float(Caml_int64.div(ps, ps_count_in_s));
  const day_rem_ps = Caml_int64.to_float(Caml_int64.mod_(ps, ps_count_in_s));
  return days_s + day_s + day_rem_ps * 1e-12;
}

function equal(param, param$1) {
  if (param[0] === param$1[0]) {
    return Stdlib__Int64.compare(param[1], param$1[1]) === 0;
  } else {
    return false;
  }
}

function compare(param, param$1) {
  const c = Caml.caml_int_compare(param[0], param$1[0]);
  if (c !== 0) {
    return c;
  } else {
    return Caml_int64.compare(param[1], param$1[1]);
  }
}

function round_div(a, b) {
  if (Caml.i64_eq(a, Caml_int64.zero)) {
    return Caml_int64.zero;
  } else {
    return Caml_int64.div(Caml_int64.add(a, Caml_int64.div(b, [
      0,
      2
    ])), b);
  }
}

const frac_div = [
  [
    232,
    3567587328
  ],
  [
    23,
    1215752192
  ],
  [
    2,
    1410065408
  ],
  [
    0,
    1000000000
  ],
  [
    0,
    100000000
  ],
  [
    0,
    10000000
  ],
  [
    0,
    1000000
  ],
  [
    0,
    100000
  ],
  [
    0,
    10000
  ],
  [
    0,
    1000
  ],
  [
    0,
    100
  ],
  [
    0,
    10
  ],
  Caml_int64.one
];

function round(frac, t) {
  const sign = t[0];
  const frac$1 = frac < 0 ? 0 : (
      frac > 12 ? 12 : frac
    );
  const match = sign < 0 ? neg(t) : t;
  const d = match[0];
  const rps = Caml_int64.mul(round_div(match[1], Caml_array.get(frac_div, frac$1)), Caml_array.get(frac_div, frac$1));
  const t$1 = Caml.i64_gt(rps, ps_day_max) ? [
      d + 1 | 0,
      Caml_int64.zero
    ] : [
      d,
      rps
    ];
  if (sign < 0) {
    return neg(t$1);
  } else {
    return t$1;
  }
}

function truncate(frac, t) {
  const sign = t[0];
  const frac$1 = frac < 0 ? 0 : (
      frac > 12 ? 12 : frac
    );
  const match = sign < 0 ? neg(t) : t;
  const ps = match[1];
  const d = match[0];
  const tps = Caml_int64.sub(ps, Caml_int64.mod_(ps, Caml_array.get(frac_div, frac$1)));
  if (sign < 0) {
    return neg([
      d,
      tps
    ]);
  } else {
    return [
      d,
      tps
    ];
  }
}

function truncate_down(frac, param) {
  const ps = param[1];
  return [
    param[0],
    Caml_int64.sub(ps, Caml_int64.mod_(ps, Caml_array.get(frac_div, frac)))
  ];
}

function dump(ppf, param) {
  Curry._2(Stdlib__Format.fprintf(ppf)({
    TAG: /* Format */ 0,
    _0: {
      TAG: /* Formatting_gen */ 18,
      _0: {
        TAG: /* Open_box */ 1,
        _0: {
          TAG: /* Format */ 0,
          _0: {
            TAG: /* String_literal */ 11,
            _0: "<1>",
            _1: /* End_of_format */ 0
          },
          _1: "<1>"
        }
      },
      _1: {
        TAG: /* Char_literal */ 12,
        _0: /* '(' */40,
        _1: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* ',' */44,
            _1: {
              TAG: /* Formatting_lit */ 17,
              _0: {
                TAG: /* Break */ 0,
                _0: "@,",
                _1: 0,
                _2: 0
              },
              _1: {
                TAG: /* Int64 */ 7,
                _0: /* Int_d */ 0,
                _1: /* No_padding */ 0,
                _2: /* No_precision */ 0,
                _3: {
                  TAG: /* Char_literal */ 12,
                  _0: /* ')' */41,
                  _1: {
                    TAG: /* Formatting_lit */ 17,
                    _0: /* Close_box */ 0,
                    _1: /* End_of_format */ 0
                  }
                }
              }
            }
          }
        }
      }
    },
    _1: "@[<1>(%d,@,%Ld)@]"
  }), param[0], param[1]);
}

function divide_ps(carry, ps, hi, lo) {
  const hi_d = Caml_int64.to_int32(Caml_int64.div(ps, hi));
  const rem_ps = Caml_int64.mod_(ps, hi);
  const lo_d = Caml_int64.to_int32(round_div(rem_ps, lo));
  if (lo_d === carry) {
    return [
      hi_d + 1 | 0,
      0
    ];
  } else {
    return [
      hi_d,
      lo_d
    ];
  }
}

function pp_unit(higher_str, hi, hi_str, frac_limit, lo, ppf, neg, ps) {
  const pp_unit_integral = function (ppf, neg, h) {
    if (h === 1000) {
      return Curry._2(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* String */ 2,
            _0: /* No_padding */ 0,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%d%s"
      }), neg ? -1 : 1, higher_str);
    } else {
      return Curry._2(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* String */ 2,
            _0: /* No_padding */ 0,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%d%s"
      }), neg ? -h | 0 : h, hi_str);
    }
  };
  if (Caml.i64_lt(ps, frac_limit)) {
    const match = divide_ps(1000, ps, hi, lo);
    const l = match[1];
    const h = match[0];
    if (h >= 100 || l === 0) {
      return pp_unit_integral(ppf, neg, h);
    }
    const h$1 = neg ? -h | 0 : h;
    return Curry._3(Stdlib__Format.fprintf(ppf)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Int */ 4,
        _0: /* Int_d */ 0,
        _1: /* No_padding */ 0,
        _2: /* No_precision */ 0,
        _3: {
          TAG: /* Char_literal */ 12,
          _0: /* '.' */46,
          _1: {
            TAG: /* Int */ 4,
            _0: /* Int_d */ 0,
            _1: /* No_padding */ 0,
            _2: /* No_precision */ 0,
            _3: {
              TAG: /* String */ 2,
              _0: /* No_padding */ 0,
              _1: /* End_of_format */ 0
            }
          }
        }
      },
      _1: "%d.%d%s"
    }), h$1, l, hi_str);
  }
  const match$1 = divide_ps(1, ps, hi, hi);
  pp_unit_integral(ppf, neg, match$1[0]);
}

function pp(ppf, s) {
  const neg = s[0] < 0;
  const match = abs(s);
  const d = match[0];
  if (d !== 0) {
    const ps = match[1];
    if (d > 365) {
      const max_d = Stdlib.max_int / 4 | 0;
      let match$1;
      if (d > max_d) {
        match$1 = [
          d / 365 | 0,
          d % 365
        ];
      } else {
        const y = (d << 2) / 1461 | 0;
        match$1 = [
          y,
          d - (Math.imul(y, 1461) / 4 | 0) | 0
        ];
      }
      const y$1 = match$1[0];
      const days = match$1[1] + Caml_int64.to_int32(round_div(ps, ps_count_in_day)) | 0;
      const match$2 = days === 366 ? [
          y$1 + 1 | 0,
          1
        ] : [
          y$1,
          days
        ];
      const days$1 = match$2[1];
      const y$2 = match$2[0];
      const y$3 = neg ? -y$2 | 0 : y$2;
      Curry._1(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* 'y' */121,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%dy"
      }), y$3);
      if (days$1 !== 0) {
        Curry._1(Stdlib__Format.fprintf(ppf)({
          TAG: /* Format */ 0,
          _0: {
            TAG: /* Int */ 4,
            _0: /* Int_d */ 0,
            _1: /* No_padding */ 0,
            _2: /* No_precision */ 0,
            _3: {
              TAG: /* Char_literal */ 12,
              _0: /* 'd' */100,
              _1: /* End_of_format */ 0
            }
          },
          _1: "%dd"
        }), days$1);
      }
      return;
    } else {
      const match$3 = divide_ps(1, ps, ps_count_in_hour, ps_count_in_hour);
      const h = match$3[0];
      const match$4 = h === 24 ? [
          d + 1 | 0,
          0
        ] : [
          d,
          h
        ];
      const h$1 = match$4[1];
      const d$1 = match$4[0];
      if (d$1 === 366) {
        return Curry._1(Stdlib__Format.fprintf(ppf)({
          TAG: /* Format */ 0,
          _0: {
            TAG: /* Int */ 4,
            _0: /* Int_d */ 0,
            _1: /* No_padding */ 0,
            _2: /* No_precision */ 0,
            _3: {
              TAG: /* String_literal */ 11,
              _0: "y1d",
              _1: /* End_of_format */ 0
            }
          },
          _1: "%dy1d"
        }), neg ? -1 : 1);
      }
      if (d$1 === 365 && h$1 >= 6) {
        return Curry._1(Stdlib__Format.fprintf(ppf)({
          TAG: /* Format */ 0,
          _0: {
            TAG: /* Int */ 4,
            _0: /* Int_d */ 0,
            _1: /* No_padding */ 0,
            _2: /* No_precision */ 0,
            _3: {
              TAG: /* Char_literal */ 12,
              _0: /* 'y' */121,
              _1: /* End_of_format */ 0
            }
          },
          _1: "%dy"
        }), neg ? -1 : 1);
      }
      const d$2 = neg ? -d$1 | 0 : d$1;
      Curry._1(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* 'd' */100,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%dd"
      }), d$2);
      if (h$1 !== 0) {
        Curry._1(Stdlib__Format.fprintf(ppf)({
          TAG: /* Format */ 0,
          _0: {
            TAG: /* Int */ 4,
            _0: /* Int_d */ 0,
            _1: /* No_padding */ 0,
            _2: /* No_precision */ 0,
            _3: {
              TAG: /* Char_literal */ 12,
              _0: /* 'h' */104,
              _1: /* End_of_format */ 0
            }
          },
          _1: "%dh"
        }), h$1);
      }
      return;
    }
  }
  const ps$1 = match[1];
  if (Caml.i64_ge(ps$1, ps_count_in_hour)) {
    const match$5 = divide_ps(60, ps$1, ps_count_in_hour, ps_count_in_min);
    const m = match$5[1];
    const h$2 = match$5[0];
    if (h$2 === 24) {
      return Curry._1(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* 'd' */100,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%dd"
      }), neg ? -1 : 1);
    }
    const h$3 = neg ? -h$2 | 0 : h$2;
    Curry._1(Stdlib__Format.fprintf(ppf)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Int */ 4,
        _0: /* Int_d */ 0,
        _1: /* No_padding */ 0,
        _2: /* No_precision */ 0,
        _3: {
          TAG: /* Char_literal */ 12,
          _0: /* 'h' */104,
          _1: /* End_of_format */ 0
        }
      },
      _1: "%dh"
    }), h$3);
    if (m !== 0) {
      Curry._1(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* String_literal */ 11,
            _0: "min",
            _1: /* End_of_format */ 0
          }
        },
        _1: "%dmin"
      }), m);
    }
    return;
  } else if (Caml.i64_ge(ps$1, ps_count_in_min)) {
    const match$6 = divide_ps(60, ps$1, ps_count_in_min, ps_count_in_s);
    const s$1 = match$6[1];
    const m$1 = match$6[0];
    if (m$1 === 60) {
      return Curry._1(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* 'h' */104,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%dh"
      }), neg ? -1 : 1);
    }
    const m$2 = neg ? -m$1 | 0 : m$1;
    Curry._1(Stdlib__Format.fprintf(ppf)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Int */ 4,
        _0: /* Int_d */ 0,
        _1: /* No_padding */ 0,
        _2: /* No_precision */ 0,
        _3: {
          TAG: /* String_literal */ 11,
          _0: "min",
          _1: /* End_of_format */ 0
        }
      },
      _1: "%dmin"
    }), m$2);
    if (s$1 !== 0) {
      Curry._1(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* 's' */115,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%ds"
      }), s$1);
    }
    return;
  } else if (Caml.i64_ge(ps$1, ps_count_in_s)) {
    const match$7 = divide_ps(1000, ps$1, ps_count_in_s, ps_count_in_ms);
    const ms = match$7[1];
    const s$2 = match$7[0];
    if (s$2 === 60) {
      return Curry._1(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* String_literal */ 11,
            _0: "min",
            _1: /* End_of_format */ 0
          }
        },
        _1: "%dmin"
      }), neg ? -1 : 1);
    }
    const s$3 = neg ? -s$2 | 0 : s$2;
    if (ms !== 0) {
      return Curry._2(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* '.' */46,
            _1: {
              TAG: /* Int */ 4,
              _0: /* Int_d */ 0,
              _1: /* No_padding */ 0,
              _2: /* No_precision */ 0,
              _3: {
                TAG: /* Char_literal */ 12,
                _0: /* 's' */115,
                _1: /* End_of_format */ 0
              }
            }
          }
        },
        _1: "%d.%ds"
      }), s$3, ms);
    } else {
      return Curry._1(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* 's' */115,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%ds"
      }), s$3);
    }
  } else if (Caml.i64_ge(ps$1, ps_count_in_ms)) {
    return pp_unit("s", ps_count_in_ms, "ms", [
      23,
      1215752192
    ], ps_count_in_us, ppf, neg, ps$1);
  } else if (Caml.i64_ge(ps$1, ps_count_in_us)) {
    return pp_unit("ms", ps_count_in_us, "us", [
      0,
      100000000
    ], ps_count_in_ns, ppf, neg, ps$1);
  } else if (Caml.i64_ge(ps$1, ps_count_in_ns)) {
    return pp_unit("us", ps_count_in_ns, "ns", [
      0,
      100000
    ], Caml_int64.one, ppf, neg, ps$1);
  } else {
    const ps$2 = Caml_int64.to_int32(ps$1);
    return Curry._1(Stdlib__Format.fprintf(ppf)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Int */ 4,
        _0: /* Int_d */ 0,
        _1: /* No_padding */ 0,
        _2: /* No_precision */ 0,
        _3: {
          TAG: /* String_literal */ 11,
          _0: "ps",
          _1: /* End_of_format */ 0
        }
      },
      _1: "%dps"
    }), neg ? -ps$2 | 0 : ps$2);
  }
}

function v$1(s) {
  const ps = s[1];
  const d = s[0];
  if (Caml.i64_lt(ps, Caml_int64.zero) || Caml.i64_gt(ps, ps_day_max) || d < day_min || d > day_max) {
    return Stdlib.invalid_arg(Curry._2(Stdlib__Format.sprintf({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* String_literal */ 11,
        _0: "illegal ptime timestamp: (",
        _1: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* ',' */44,
            _1: {
              TAG: /* Int64 */ 7,
              _0: /* Int_d */ 0,
              _1: /* No_padding */ 0,
              _2: /* No_precision */ 0,
              _3: {
                TAG: /* Char_literal */ 12,
                _0: /* ')' */41,
                _1: /* End_of_format */ 0
              }
            }
          }
        }
      },
      _1: "illegal ptime timestamp: (%d,%Ld)"
    }), d, ps));
  } else {
    return s;
  }
}

function unsafe_of_d_ps$1(s) {
  return s;
}

function of_span(span) {
  const d = span[0];
  if (d < day_min || d > day_max) {
    return;
  } else {
    return span;
  }
}

function to_span(t) {
  return t;
}

function of_float_s$1(secs) {
  const d = of_float_s(secs);
  if (d !== undefined) {
    return of_span(d);
  }
  
}

function frac_s(param) {
  return [
    0,
    Caml_int64.mod_(param[1], ps_count_in_s)
  ];
}

function is_earlier(t, than) {
  return compare(t, than) === -1;
}

function is_later(t, than) {
  return compare(t, than) === 1;
}

function add_span(t, d) {
  return of_span(add(t, d));
}

function sub_span(t, d) {
  return of_span(add(t, neg(d)));
}

function diff(t1, t0) {
  return add(t1, neg(t0));
}

function is_leap_year(y) {
  if (y % 4 === 0) {
    if (y % 100 !== 0) {
      return true;
    } else {
      return y % 400 === 0;
    }
  } else {
    return false;
  }
}

const mlen = [
  31,
  28,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];

function max_month_day(y, m) {
  if (m === 2 && is_leap_year(y)) {
    return 29;
  } else {
    return Caml_array.get(mlen, m - 1 | 0);
  }
}

function is_date_valid(param) {
  const d = param[2];
  const m = param[1];
  const y = param[0];
  if (0 <= y && y <= 9999 && 1 <= m && m <= 12 && 1 <= d) {
    return d <= max_month_day(y, m);
  } else {
    return false;
  }
}

function is_time_valid(param) {
  const match = param[0];
  const ss = match[2];
  const mm = match[1];
  const hh = match[0];
  if (0 <= hh && hh <= 23 && 0 <= mm && mm <= 59 && 0 <= ss) {
    return ss <= 60;
  } else {
    return false;
  }
}

function of_date_time(param) {
  const t = param[1];
  const match = t[0];
  const date = param[0];
  if (!(is_date_valid(date) && is_time_valid(t))) {
    return;
  }
  const d = jd_of_date(date) - 2440588 | 0;
  const hh_ps = Caml_int64.mul(Caml_int64.of_int32(match[0]), ps_count_in_hour);
  const mm_ps = Caml_int64.mul(Caml_int64.of_int32(match[1]), ps_count_in_min);
  const ss_ps = Caml_int64.mul(Caml_int64.of_int32(match[2]), ps_count_in_s);
  const ps = Caml_int64.add(hh_ps, Caml_int64.add(mm_ps, ss_ps));
  const d$1 = of_int_s(t[1]);
  return of_span(add([
    d,
    ps
  ], neg(d$1)));
}

function to_date_time(tz_offset_sOpt, t) {
  const tz_offset_s = tz_offset_sOpt !== undefined ? tz_offset_sOpt : 0;
  const d = of_int_s(tz_offset_s);
  const local = of_span(add(t, d));
  const match = local !== undefined ? [
      local,
      tz_offset_s
    ] : [
      t,
      0
    ];
  const match$1 = match[0];
  const ps = match$1[1];
  const jd = match$1[0] + 2440588 | 0;
  const date = jd_to_date(jd);
  const hh = Caml_int64.to_int32(Caml_int64.div(ps, ps_count_in_hour));
  const hh_rem = Caml_int64.mod_(ps, ps_count_in_hour);
  const mm = Caml_int64.to_int32(Caml_int64.div(hh_rem, ps_count_in_min));
  const mm_rem = Caml_int64.mod_(hh_rem, ps_count_in_min);
  const ss = Caml_int64.to_int32(Caml_int64.div(mm_rem, ps_count_in_s));
  return [
    date,
    [
      [
        hh,
        mm,
        ss
      ],
      match[1]
    ]
  ];
}

function of_date(tzOpt, date) {
  const tz = tzOpt !== undefined ? tzOpt : 0;
  return of_date_time([
    date,
    [
      [
        0,
        0,
        0
      ],
      tz
    ]
  ]);
}

function to_date(tz_offset_s, t) {
  return to_date_time(tz_offset_s, t)[0];
}

function of_year(tz_offset_s, y) {
  return of_date(tz_offset_s, [
    y,
    1,
    1
  ]);
}

function to_year(tz_offset_sOpt, t) {
  const tz_offset_s = tz_offset_sOpt !== undefined ? tz_offset_sOpt : 0;
  const d = of_int_s(tz_offset_s);
  const match = of_span(add(t, d));
  const d$1 = match !== undefined ? match[0] : t[0];
  let jd = d$1 + 2440588 | 0;
  const a = jd + 32044 | 0;
  const b = ((a << 2) + 3 | 0) / 146097 | 0;
  const c = a - (Math.imul(146097, b) / 4 | 0) | 0;
  const d$2 = ((c << 2) + 3 | 0) / 1461 | 0;
  const e = c - (Math.imul(1461, d$2) / 4 | 0) | 0;
  const m = (Math.imul(5, e) + 2 | 0) / 153 | 0;
  return ((Math.imul(100, b) + d$2 | 0) - 4800 | 0) + (m / 10 | 0) | 0;
}

function weekday_num(tz_offset_sOpt, t) {
  const tz_offset_s = tz_offset_sOpt !== undefined ? tz_offset_sOpt : 0;
  const match = add(t, of_int_s(tz_offset_s));
  const i = (match[0] + 4 | 0) % 7;
  if (i < 0) {
    return 7 + i | 0;
  } else {
    return i;
  }
}

const wday = [
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat"
];

function weekday(tz_offset_s, t) {
  return Caml_array.get(wday, weekday_num(tz_offset_s, t));
}

function pp_rfc3339_error(ppf, param) {
  if (typeof param === "string") {
    if (param === "Eoi") {
      return Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: /* End_of_format */ 0,
              _1: ""
            }
          },
          _1: {
            TAG: /* String_literal */ 11,
            _0: "unexpected",
            _1: {
              TAG: /* Formatting_lit */ 17,
              _0: {
                TAG: /* Break */ 0,
                _0: "@ ",
                _1: 1,
                _2: 0
              },
              _1: {
                TAG: /* String_literal */ 11,
                _0: "end",
                _1: {
                  TAG: /* Formatting_lit */ 17,
                  _0: {
                    TAG: /* Break */ 0,
                    _0: "@ ",
                    _1: 1,
                    _2: 0
                  },
                  _1: {
                    TAG: /* String_literal */ 11,
                    _0: "of",
                    _1: {
                      TAG: /* Formatting_lit */ 17,
                      _0: {
                        TAG: /* Break */ 0,
                        _0: "@ ",
                        _1: 1,
                        _2: 0
                      },
                      _1: {
                        TAG: /* String_literal */ 11,
                        _0: "input",
                        _1: {
                          TAG: /* Formatting_lit */ 17,
                          _0: /* Close_box */ 0,
                          _1: /* End_of_format */ 0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        },
        _1: "@[unexpected@ end@ of@ input@]"
      });
    } else if (param === "Invalid_stamp") {
      return Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: /* End_of_format */ 0,
              _1: ""
            }
          },
          _1: {
            TAG: /* String_literal */ 11,
            _0: "invalid",
            _1: {
              TAG: /* Formatting_lit */ 17,
              _0: {
                TAG: /* Break */ 0,
                _0: "@ ",
                _1: 1,
                _2: 0
              },
              _1: {
                TAG: /* String_literal */ 11,
                _0: "time",
                _1: {
                  TAG: /* Formatting_lit */ 17,
                  _0: {
                    TAG: /* Break */ 0,
                    _0: "@ ",
                    _1: 1,
                    _2: 0
                  },
                  _1: {
                    TAG: /* String_literal */ 11,
                    _0: "stamp",
                    _1: {
                      TAG: /* Formatting_lit */ 17,
                      _0: /* Close_box */ 0,
                      _1: /* End_of_format */ 0
                    }
                  }
                }
              }
            }
          }
        },
        _1: "@[invalid@ time@ stamp@]"
      });
    } else {
      return Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: /* End_of_format */ 0,
              _1: ""
            }
          },
          _1: {
            TAG: /* String_literal */ 11,
            _0: "trailing",
            _1: {
              TAG: /* Formatting_lit */ 17,
              _0: {
                TAG: /* Break */ 0,
                _0: "@ ",
                _1: 1,
                _2: 0
              },
              _1: {
                TAG: /* String_literal */ 11,
                _0: "input",
                _1: {
                  TAG: /* Formatting_lit */ 17,
                  _0: /* Close_box */ 0,
                  _1: /* End_of_format */ 0
                }
              }
            }
          }
        },
        _1: "@[trailing@ input@]"
      });
    }
  }
  const pp_chars = function (ppf, _param) {
    while (true) {
      const param = _param;
      if (!param) {
        return;
      }
      Curry._1(Stdlib__Format.fprintf(ppf)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_lit */ 17,
          _0: {
            TAG: /* Break */ 0,
            _0: "@ ",
            _1: 1,
            _2: 0
          },
          _1: {
            TAG: /* Caml_char */ 1,
            _0: /* End_of_format */ 0
          }
        },
        _1: "@ %C"
      }), param.hd);
      _param = param.tl;
      continue;
    };
  };
  Curry._2(Stdlib__Format.fprintf(ppf)({
    TAG: /* Format */ 0,
    _0: {
      TAG: /* Formatting_gen */ 18,
      _0: {
        TAG: /* Open_box */ 1,
        _0: {
          TAG: /* Format */ 0,
          _0: /* End_of_format */ 0,
          _1: ""
        }
      },
      _1: {
        TAG: /* String_literal */ 11,
        _0: "expected",
        _1: {
          TAG: /* Formatting_lit */ 17,
          _0: {
            TAG: /* Break */ 0,
            _0: "@ ",
            _1: 1,
            _2: 0
          },
          _1: {
            TAG: /* Char_literal */ 12,
            _0: /* 'a' */97,
            _1: {
              TAG: /* Formatting_lit */ 17,
              _0: {
                TAG: /* Break */ 0,
                _0: "@ ",
                _1: 1,
                _2: 0
              },
              _1: {
                TAG: /* String_literal */ 11,
                _0: "character",
                _1: {
                  TAG: /* Formatting_lit */ 17,
                  _0: {
                    TAG: /* Break */ 0,
                    _0: "@ ",
                    _1: 1,
                    _2: 0
                  },
                  _1: {
                    TAG: /* String_literal */ 11,
                    _0: "in:",
                    _1: {
                      TAG: /* Alpha */ 15,
                      _0: {
                        TAG: /* Formatting_lit */ 17,
                        _0: /* Close_box */ 0,
                        _1: /* End_of_format */ 0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    _1: "@[expected@ a@ character@ in:%a@]"
  }), pp_chars, param.VAL);
}

function pp_range(ppf, param) {
  const e = param[1];
  const s = param[0];
  if (s === e) {
    return Stdlib__Format.pp_print_int(ppf, s);
  } else {
    return Curry._2(Stdlib__Format.fprintf(ppf)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Int */ 4,
        _0: /* Int_d */ 0,
        _1: /* No_padding */ 0,
        _2: /* No_precision */ 0,
        _3: {
          TAG: /* Char_literal */ 12,
          _0: /* '-' */45,
          _1: {
            TAG: /* Int */ 4,
            _0: /* Int_d */ 0,
            _1: /* No_padding */ 0,
            _2: /* No_precision */ 0,
            _3: /* End_of_format */ 0
          }
        }
      },
      _1: "%d-%d"
    }), s, e);
  }
}

function _rfc3339_error_to_string(param) {
  return Curry._4(Stdlib__Format.asprintf({
    TAG: /* Format */ 0,
    _0: {
      TAG: /* Formatting_gen */ 18,
      _0: {
        TAG: /* Open_box */ 1,
        _0: {
          TAG: /* Format */ 0,
          _0: {
            TAG: /* String_literal */ 11,
            _0: "<h>",
            _1: /* End_of_format */ 0
          },
          _1: "<h>"
        }
      },
      _1: {
        TAG: /* Alpha */ 15,
        _0: {
          TAG: /* String_literal */ 11,
          _0: ": ",
          _1: {
            TAG: /* Alpha */ 15,
            _0: {
              TAG: /* Formatting_lit */ 17,
              _0: /* Close_box */ 0,
              _1: /* End_of_format */ 0
            }
          }
        }
      }
    },
    _1: "@[<h>%a: %a@]"
  }), pp_range, param[0], pp_rfc3339_error, param[1]);
}

function rfc3339_string_error(v) {
  if (v.TAG === /* Ok */ 0) {
    return v;
  } else {
    return {
      TAG: /* Error */ 1,
      _0: _rfc3339_error_to_string(v._0.VAL)
    };
  }
}

function rfc3339_error_to_msg(v) {
  if (v.TAG === /* Ok */ 0) {
    return v;
  } else {
    return {
      TAG: /* Error */ 1,
      _0: {
        NAME: "Msg",
        VAL: _rfc3339_error_to_string(v._0.VAL)
      }
    };
  }
}

const RFC3339 = /* @__PURE__ */ Caml_exceptions.create("Ocaml_protoc_plugin__Ptime.RFC3339");

function error_pos(p, e) {
  throw new Caml_js_exceptions.MelangeError(RFC3339, {
        MEL_EXN_ID: RFC3339,
        _1: [
          p,
          p
        ],
        _2: e
      });
}

function error_exp_digit(p) {
  return error_pos(p, {
    NAME: "Exp_chars",
    VAL: {
      hd: /* '0' */48,
      tl: {
        hd: /* '1' */49,
        tl: {
          hd: /* '2' */50,
          tl: {
            hd: /* '3' */51,
            tl: {
              hd: /* '4' */52,
              tl: {
                hd: /* '5' */53,
                tl: {
                  hd: /* '6' */54,
                  tl: {
                    hd: /* '7' */55,
                    tl: {
                      hd: /* '8' */56,
                      tl: {
                        hd: /* '9' */57,
                        tl: /* [] */ 0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });
}

function parse_digits(count, pos, max, s) {
  const stop = (pos + count | 0) - 1 | 0;
  if (stop > max) {
    return error_pos(max, "Eoi");
  }
  let _k = pos;
  let _acc = 0;
  while (true) {
    const acc = _acc;
    const k = _k;
    if (k > stop) {
      return acc;
    }
    if ((Caml_string.get(s, k) - 48 >>> 0) > 9) {
      return error_exp_digit(k);
    }
    _acc = (Math.imul(acc, 10) + Caml_string.get(s, k) | 0) - 48 | 0;
    _k = k + 1 | 0;
    continue;
  };
}

function parse_char(c, pos, max, s) {
  if (pos > max) {
    return error_pos(max, "Eoi");
  } else if (Caml_string.get(s, pos) === c) {
    return;
  } else {
    return error_pos(pos, {
      NAME: "Exp_chars",
      VAL: {
        hd: c,
        tl: /* [] */ 0
      }
    });
  }
}

function parse_dt_sep(strict, pos, max, s) {
  const is_dt_sep = function (param) {
    if (param > 115 || param < 33) {
      if (param > 116 || param < 32) {
        return false;
      } else {
        return !strict;
      }
    } else {
      return param === 84;
    }
  };
  if (pos > max) {
    return error_pos(max, "Eoi");
  } else if (is_dt_sep(Caml_string.get(s, pos))) {
    return;
  } else {
    return error_pos(pos, {
      NAME: "Exp_chars",
      VAL: Stdlib.$at({
        hd: /* 'T' */84,
        tl: /* [] */ 0
      }, strict ? /* [] */ 0 : ({
          hd: /* 't' */116,
          tl: {
            hd: /* ' ' */32,
            tl: /* [] */ 0
          }
        }))
    });
  }
}

function decide_frac_or_tz(strict, pos, max, s) {
  if (pos > max) {
    return error_pos(max, "Eoi");
  }
  const _c = Caml_string.get(s, pos);
  if (_c >= 90) {
    if (_c !== 122) {
      if (_c < 91) {
        return "Tz";
      }
      
    } else if (!strict) {
      return "Tz";
    }
    
  } else if (_c >= 44) {
    if (_c < 47) {
      switch (_c) {
        case 44 :
          break;
        case 45 :
          return "Tz";
        case 46 :
          return "Frac";
      }
    }
    
  } else if (_c >= 43) {
    return "Tz";
  }
  const chars = Stdlib.$at({
    hd: /* '.' */46,
    tl: {
      hd: /* '+' */43,
      tl: {
        hd: /* '-' */45,
        tl: {
          hd: /* 'Z' */90,
          tl: /* [] */ 0
        }
      }
    }
  }, strict ? /* [] */ 0 : ({
      hd: /* 'z' */122,
      tl: /* [] */ 0
    }));
  return error_pos(pos, {
    NAME: "Exp_chars",
    VAL: chars
  });
}

function parse_frac_ps(pos, max, s) {
  if (pos > max) {
    return error_pos(max, "Eoi");
  }
  if ((Caml_string.get(s, pos) - 48 >>> 0) > 9) {
    return error_exp_digit(pos);
  }
  let _k = pos;
  let _acc = Caml_int64.zero;
  let _pow = ps_count_in_s;
  while (true) {
    const pow = _pow;
    const acc = _acc;
    const k = _k;
    if (k > max) {
      return error_pos(max, "Eoi");
    }
    if ((Caml_string.get(s, k) - 48 >>> 0) > 9) {
      return [
        acc,
        k
      ];
    }
    const count = (k - pos | 0) + 1 | 0;
    if (count > 12) {
      _k = k + 1 | 0;
      continue;
    }
    const pow$1 = Caml_int64.div(pow, [
      0,
      10
    ]);
    const acc$1 = Caml_int64.add(acc, Caml_int64.mul(Caml_int64.of_int32(Caml_string.get(s, k) - 48 | 0), pow$1));
    _pow = pow$1;
    _acc = acc$1;
    _k = k + 1 | 0;
    continue;
  };
}

function parse_tz_s(strict, pos, max, s) {
  const parse_tz_mag = function (sign, pos) {
    const hh = parse_digits(2, pos, max, s);
    let match;
    if (strict) {
      const mm_pos = pos + 3 | 0;
      parse_char(/* ':' */58, mm_pos - 1 | 0, max, s);
      match = [
        parse_digits(2, mm_pos, max, s),
        mm_pos
      ];
    } else {
      const next = pos + 2 | 0;
      if (next > max || !(Caml_string.get(s, next) === /* ':' */58 || (Caml_string.get(s, next) - 48 >>> 0) <= 9)) {
        match = [
          0,
          pos
        ];
      } else {
        const mm_pos$1 = Caml_string.get(s, next) === /* ':' */58 ? pos + 3 | 0 : pos + 2 | 0;
        match = [
          parse_digits(2, mm_pos$1, max, s),
          mm_pos$1
        ];
      }
    }
    const mm_pos$2 = match[1];
    const mm = match[0];
    if (hh > 23) {
      throw new Caml_js_exceptions.MelangeError(RFC3339, {
            MEL_EXN_ID: RFC3339,
            _1: [
              pos,
              pos + 1 | 0
            ],
            _2: "Invalid_stamp"
          });
    }
    if (mm > 59) {
      throw new Caml_js_exceptions.MelangeError(RFC3339, {
            MEL_EXN_ID: RFC3339,
            _1: [
              mm_pos$2,
              mm_pos$2 + 1 | 0
            ],
            _2: "Invalid_stamp"
          });
    }
    const secs = Math.imul(hh, 3600) + Math.imul(mm, 60) | 0;
    const tz_s = secs === 0 && sign === -1 ? undefined : Math.imul(sign, secs);
    return [
      tz_s,
      mm_pos$2 + 1 | 0
    ];
  };
  if (pos > max) {
    return error_pos(max, "Eoi");
  }
  const _c = Caml_string.get(s, pos);
  if (_c === 90) {
    return [
      0,
      pos
    ];
  }
  if (_c >= 46) {
    if (_c === 122 && !strict) {
      return [
        0,
        pos
      ];
    }
    
  } else if (_c >= 43) {
    switch (_c) {
      case 43 :
        return parse_tz_mag(1, pos + 1 | 0);
      case 44 :
        break;
      case 45 :
        return parse_tz_mag(-1, pos + 1 | 0);
    }
  }
  const chars = Stdlib.$at({
    hd: /* '+' */43,
    tl: {
      hd: /* '-' */45,
      tl: {
        hd: /* 'Z' */90,
        tl: /* [] */ 0
      }
    }
  }, strict ? /* [] */ 0 : ({
      hd: /* 'z' */122,
      tl: /* [] */ 0
    }));
  return error_pos(pos, {
    NAME: "Exp_chars",
    VAL: chars
  });
}

function of_rfc3339(strictOpt, subOpt, startOpt, s) {
  const strict = strictOpt !== undefined ? strictOpt : false;
  const sub = subOpt !== undefined ? subOpt : false;
  const start = startOpt !== undefined ? startOpt : 0;
  try {
    const s_len = s.length;
    const max = s_len - 1 | 0;
    if (s_len === 0 || start < 0 || start > max) {
      return error_pos(start, "Eoi");
    }
    const m_pos = start + 5 | 0;
    const d_pos = m_pos + 3 | 0;
    const hh_pos = d_pos + 3 | 0;
    const mm_pos = hh_pos + 3 | 0;
    const ss_pos = mm_pos + 3 | 0;
    const decide_pos = ss_pos + 2 | 0;
    const y = parse_digits(4, start, max, s);
    parse_char(/* '-' */45, m_pos - 1 | 0, max, s);
    const m = parse_digits(2, m_pos, max, s);
    parse_char(/* '-' */45, d_pos - 1 | 0, max, s);
    const d = parse_digits(2, d_pos, max, s);
    parse_dt_sep(strict, hh_pos - 1 | 0, max, s);
    const hh = parse_digits(2, hh_pos, max, s);
    parse_char(/* ':' */58, mm_pos - 1 | 0, max, s);
    const mm = parse_digits(2, mm_pos, max, s);
    parse_char(/* ':' */58, ss_pos - 1 | 0, max, s);
    const ss = parse_digits(2, ss_pos, max, s);
    const match = decide_frac_or_tz(strict, decide_pos, max, s);
    const match$1 = match === "Frac" ? parse_frac_ps(decide_pos + 1 | 0, max, s) : [
        undefined,
        decide_pos
      ];
    const frac = match$1[0];
    const match$2 = parse_tz_s(strict, match$1[1], max, s);
    const last_pos = match$2[1];
    const tz_s_opt = match$2[0];
    const tz_s = tz_s_opt !== undefined ? tz_s_opt : 0;
    const t = of_date_time([
      [
        y,
        m,
        d
      ],
      [
        [
          hh,
          mm,
          ss
        ],
        tz_s
      ]
    ]);
    if (t !== undefined) {
      let match$3;
      if (frac !== undefined && Caml.i64_neq(frac, Caml_int64.zero)) {
        const t$1 = of_span(add(t, [
          0,
          frac
        ]));
        if (t$1 !== undefined) {
          match$3 = [
            t$1,
            tz_s
          ];
        } else {
          throw new Caml_js_exceptions.MelangeError(RFC3339, {
                MEL_EXN_ID: RFC3339,
                _1: [
                  start,
                  last_pos
                ],
                _2: "Invalid_stamp"
              });
        }
      } else {
        match$3 = [
          t,
          tz_s
        ];
      }
      if (!sub && last_pos !== max) {
        return error_pos(last_pos + 1 | 0, "Trailing_input");
      } else {
        return {
          TAG: /* Ok */ 0,
          _0: [
            match$3[0],
            tz_s_opt,
            (last_pos - start | 0) + 1 | 0
          ]
        };
      }
    }
    throw new Caml_js_exceptions.MelangeError(RFC3339, {
          MEL_EXN_ID: RFC3339,
          _1: [
            start,
            last_pos
          ],
          _2: "Invalid_stamp"
        });
  }
  catch (raw_exn){
    const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.MEL_EXN_ID === RFC3339) {
      return {
        TAG: /* Error */ 1,
        _0: {
          NAME: "RFC3339",
          VAL: [
            exn._1,
            exn._2
          ]
        }
      };
    }
    throw new Caml_js_exceptions.MelangeError(exn.MEL_EXN_ID, exn);
  }
}

function rfc3339_adjust_tz_offset(tz_offset_s) {
  if (-86340 <= tz_offset_s && tz_offset_s <= 86340 && tz_offset_s % 60 === 0) {
    return [
      tz_offset_s,
      false
    ];
  } else {
    return [
      0,
      true
    ];
  }
}

function s_frac_of_ps(frac, ps) {
  return Caml_int64.div(Caml_int64.mod_(ps, ps_count_in_s), Caml_array.get(frac_div, frac));
}

function to_rfc3339(spaceOpt, fracOpt, tz_offset_s, t) {
  const space = spaceOpt !== undefined ? spaceOpt : false;
  const frac = fracOpt !== undefined ? fracOpt : 0;
  const buf = Stdlib__Buffer.create(255);
  const match = tz_offset_s !== undefined ? rfc3339_adjust_tz_offset(tz_offset_s) : [
      0,
      true
    ];
  const tz_unknown = match[1];
  const match$1 = to_date_time(match[0], t);
  const match$2 = match$1[1];
  const tz_offset_s$1 = match$2[1];
  const match$3 = match$2[0];
  const match$4 = match$1[0];
  const dt_sep = space ? /* ' ' */32 : /* 'T' */84;
  Curry._7(Stdlib__Printf.bprintf(buf, {
    TAG: /* Format */ 0,
    _0: {
      TAG: /* Int */ 4,
      _0: /* Int_d */ 0,
      _1: {
        TAG: /* Lit_padding */ 0,
        _0: /* Zeros */ 2,
        _1: 4
      },
      _2: /* No_precision */ 0,
      _3: {
        TAG: /* Char_literal */ 12,
        _0: /* '-' */45,
        _1: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: {
            TAG: /* Lit_padding */ 0,
            _0: /* Zeros */ 2,
            _1: 2
          },
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* '-' */45,
            _1: {
              TAG: /* Int */ 4,
              _0: /* Int_d */ 0,
              _1: {
                TAG: /* Lit_padding */ 0,
                _0: /* Zeros */ 2,
                _1: 2
              },
              _2: /* No_precision */ 0,
              _3: {
                TAG: /* Char */ 0,
                _0: {
                  TAG: /* Int */ 4,
                  _0: /* Int_d */ 0,
                  _1: {
                    TAG: /* Lit_padding */ 0,
                    _0: /* Zeros */ 2,
                    _1: 2
                  },
                  _2: /* No_precision */ 0,
                  _3: {
                    TAG: /* Char_literal */ 12,
                    _0: /* ':' */58,
                    _1: {
                      TAG: /* Int */ 4,
                      _0: /* Int_d */ 0,
                      _1: {
                        TAG: /* Lit_padding */ 0,
                        _0: /* Zeros */ 2,
                        _1: 2
                      },
                      _2: /* No_precision */ 0,
                      _3: {
                        TAG: /* Char_literal */ 12,
                        _0: /* ':' */58,
                        _1: {
                          TAG: /* Int */ 4,
                          _0: /* Int_d */ 0,
                          _1: {
                            TAG: /* Lit_padding */ 0,
                            _0: /* Zeros */ 2,
                            _1: 2
                          },
                          _2: /* No_precision */ 0,
                          _3: /* End_of_format */ 0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    _1: "%04d-%02d-%02d%c%02d:%02d:%02d"
  }), match$4[0], match$4[1], match$4[2], dt_sep, match$3[0], match$3[1], match$3[2]);
  const frac$1 = frac < 0 ? 0 : (
      frac > 12 ? 12 : frac
    );
  if (frac$1 !== 0) {
    Curry._2(Stdlib__Printf.bprintf(buf, {
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Char_literal */ 12,
        _0: /* '.' */46,
        _1: {
          TAG: /* Int64 */ 7,
          _0: /* Int_d */ 0,
          _1: {
            TAG: /* Arg_padding */ 1,
            _0: /* Zeros */ 2
          },
          _2: /* No_precision */ 0,
          _3: /* End_of_format */ 0
        }
      },
      _1: ".%0*Ld"
    }), frac$1, s_frac_of_ps(frac$1, t[1]));
  }
  if (tz_offset_s$1 === 0 && !tz_unknown) {
    Stdlib__Printf.bprintf(buf, {
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Char_literal */ 12,
        _0: /* 'Z' */90,
        _1: /* End_of_format */ 0
      },
      _1: "Z"
    });
  } else {
    const tz_sign = tz_offset_s$1 < 0 || tz_unknown ? /* '-' */45 : /* '+' */43;
    const tz_min = Stdlib.abs(tz_offset_s$1 / 60 | 0);
    const tz_hh = tz_min / 60 | 0;
    const tz_mm = tz_min % 60;
    Curry._3(Stdlib__Printf.bprintf(buf, {
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Char */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: {
            TAG: /* Lit_padding */ 0,
            _0: /* Zeros */ 2,
            _1: 2
          },
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* ':' */58,
            _1: {
              TAG: /* Int */ 4,
              _0: /* Int_d */ 0,
              _1: {
                TAG: /* Lit_padding */ 0,
                _0: /* Zeros */ 2,
                _1: 2
              },
              _2: /* No_precision */ 0,
              _3: /* End_of_format */ 0
            }
          }
        }
      },
      _1: "%c%02d:%02d"
    }), tz_sign, tz_hh, tz_mm);
  }
  return Stdlib__Buffer.contents(buf);
}

function pp_rfc3339(space, frac_s, tz_offset_s, param, ppf, t) {
  Curry._1(Stdlib__Format.fprintf(ppf)({
    TAG: /* Format */ 0,
    _0: {
      TAG: /* String */ 2,
      _0: /* No_padding */ 0,
      _1: /* End_of_format */ 0
    },
    _1: "%s"
  }), to_rfc3339(space, frac_s, tz_offset_s, t));
}

function pp_human(fracOpt, tz_offset_s, param, ppf, t) {
  const frac = fracOpt !== undefined ? fracOpt : 0;
  const match = tz_offset_s !== undefined ? rfc3339_adjust_tz_offset(tz_offset_s) : [
      0,
      true
    ];
  const match$1 = to_date_time(match[0], t);
  const match$2 = match$1[1];
  const tz_offset_s$1 = match$2[1];
  const match$3 = match$2[0];
  const match$4 = match$1[0];
  Curry._6(Stdlib__Format.fprintf(ppf)({
    TAG: /* Format */ 0,
    _0: {
      TAG: /* Int */ 4,
      _0: /* Int_d */ 0,
      _1: {
        TAG: /* Lit_padding */ 0,
        _0: /* Zeros */ 2,
        _1: 4
      },
      _2: /* No_precision */ 0,
      _3: {
        TAG: /* Char_literal */ 12,
        _0: /* '-' */45,
        _1: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: {
            TAG: /* Lit_padding */ 0,
            _0: /* Zeros */ 2,
            _1: 2
          },
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* '-' */45,
            _1: {
              TAG: /* Int */ 4,
              _0: /* Int_d */ 0,
              _1: {
                TAG: /* Lit_padding */ 0,
                _0: /* Zeros */ 2,
                _1: 2
              },
              _2: /* No_precision */ 0,
              _3: {
                TAG: /* Char_literal */ 12,
                _0: /* ' ' */32,
                _1: {
                  TAG: /* Int */ 4,
                  _0: /* Int_d */ 0,
                  _1: {
                    TAG: /* Lit_padding */ 0,
                    _0: /* Zeros */ 2,
                    _1: 2
                  },
                  _2: /* No_precision */ 0,
                  _3: {
                    TAG: /* Char_literal */ 12,
                    _0: /* ':' */58,
                    _1: {
                      TAG: /* Int */ 4,
                      _0: /* Int_d */ 0,
                      _1: {
                        TAG: /* Lit_padding */ 0,
                        _0: /* Zeros */ 2,
                        _1: 2
                      },
                      _2: /* No_precision */ 0,
                      _3: {
                        TAG: /* Char_literal */ 12,
                        _0: /* ':' */58,
                        _1: {
                          TAG: /* Int */ 4,
                          _0: /* Int_d */ 0,
                          _1: {
                            TAG: /* Lit_padding */ 0,
                            _0: /* Zeros */ 2,
                            _1: 2
                          },
                          _2: /* No_precision */ 0,
                          _3: /* End_of_format */ 0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    _1: "%04d-%02d-%02d %02d:%02d:%02d"
  }), match$4[0], match$4[1], match$4[2], match$3[0], match$3[1], match$3[2]);
  const frac$1 = frac < 0 ? 0 : (
      frac > 12 ? 12 : frac
    );
  if (frac$1 !== 0) {
    Curry._2(Stdlib__Format.fprintf(ppf)({
      TAG: /* Format */ 0,
      _0: {
        TAG: /* Char_literal */ 12,
        _0: /* '.' */46,
        _1: {
          TAG: /* Int64 */ 7,
          _0: /* Int_d */ 0,
          _1: {
            TAG: /* Arg_padding */ 1,
            _0: /* Zeros */ 2
          },
          _2: /* No_precision */ 0,
          _3: /* End_of_format */ 0
        }
      },
      _1: ".%0*Ld"
    }), frac$1, s_frac_of_ps(frac$1, t[1]));
  }
  const tz_sign = tz_offset_s$1 < 0 || match[1] ? /* '-' */45 : /* '+' */43;
  const tz_min = Stdlib.abs(tz_offset_s$1 / 60 | 0);
  const tz_hh = tz_min / 60 | 0;
  const tz_mm = tz_min % 60;
  Curry._3(Stdlib__Format.fprintf(ppf)({
    TAG: /* Format */ 0,
    _0: {
      TAG: /* Char_literal */ 12,
      _0: /* ' ' */32,
      _1: {
        TAG: /* Char */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: {
            TAG: /* Lit_padding */ 0,
            _0: /* Zeros */ 2,
            _1: 2
          },
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* ':' */58,
            _1: {
              TAG: /* Int */ 4,
              _0: /* Int_d */ 0,
              _1: {
                TAG: /* Lit_padding */ 0,
                _0: /* Zeros */ 2,
                _1: 2
              },
              _2: /* No_precision */ 0,
              _3: /* End_of_format */ 0
            }
          }
        }
      }
    },
    _1: " %c%02d:%02d"
  }), tz_sign, tz_hh, tz_mm);
}

const partial_arg = 0;

function pp$1(param, param$1) {
  return pp_human(undefined, partial_arg, undefined, param, param$1);
}

const Span_zero = [
  0,
  Caml_int64.zero
];

const Span = {
  v: v,
  zero: Span_zero,
  of_d_ps: of_d_ps,
  unsafe_of_d_ps: unsafe_of_d_ps,
  unsafe_of_d_ps_option: unsafe_of_d_ps_option,
  to_d_ps: to_d_ps,
  of_int_s: of_int_s,
  to_int_s: to_int_s,
  of_float_s: of_float_s,
  to_float_s: to_float_s,
  equal: equal,
  compare: compare,
  neg: neg,
  add: add,
  sub: sub,
  abs: abs,
  round: round,
  truncate: truncate,
  pp: pp,
  dump: dump
};

const epoch = [
  0,
  Caml_int64.zero
];

const truncate$1 = truncate_down;

export {
  Span,
  v$1 as v,
  epoch,
  min,
  max,
  of_span,
  to_span,
  unsafe_of_d_ps$1 as unsafe_of_d_ps,
  of_float_s$1 as of_float_s,
  to_float_s,
  truncate$1 as truncate,
  frac_s,
  equal,
  compare,
  is_earlier,
  is_later,
  add_span,
  sub_span,
  diff,
  of_date_time,
  to_date_time,
  of_date,
  to_date,
  of_year,
  to_year,
  weekday,
  weekday_num,
  pp_rfc3339_error,
  rfc3339_error_to_msg,
  rfc3339_string_error,
  of_rfc3339,
  to_rfc3339,
  pp_rfc3339,
  pp_human,
  pp$1 as pp,
  dump,
}
/* Stdlib__Format Not a pure module */
